<template>
  <div>
    <topMenu Sel="4"></topMenu>
    <div>
    	<img src="../../../static/image/img5.png" style="width: 100%;"/>
    </div>
    <div class="titlebox">
    	<p class="title">JOIN THE PROCESS</p>
    	<div>
    		<div class="titleleft"></div>
    		<div class="titlemiddle">合作流程</div>
    		<div class="titleright"></div>
    	</div>
    </div>
    <div class="box">
    	<div>
    		<img src="../../../static/image/hezuo1.png"/>
    		<p>申请</p>
    	</div>
    	<div>
    		<img src="../../../static/image/hezuo2.png"/>
    		<p>审批</p>
    	</div>
    	<div>
    		<img src="../../../static/image/hezuo3.png"/>
    		<p>完成</p>
    	</div>
    </div>

    <div class="titlebox">
    	<p class="title">JOIN THE PROCESS</p>
    	<div>
    		<div class="titleleft"></div>
    		<div class="titlemiddle">合作介绍</div>
    		<div class="titleright"></div>
    	</div>
    </div>
    <div class="hzjs">
    	<div class="hzjsbox">
    		<p>
    			城市代理说明:城市代理说明城市代理说明城市代理说明城市代理说明城市代理说明城市代理说明城市代理说明
    			城市代理说明城市代理说明城市代理说明城市代理说明城市代理说明城市代理说明城市代理说明城市代理说明
    			城市代理说明城市代理说明城市代理说明城市代理说明城市代理说明城市代理说明城市代理说明城市代理说明
    		</p>
    		<p>
    			广告合作说明:广告合作说明广告合作说明广告合作说明广告合作说明广告合作说明广告合作说明广告合作说明
    			广告合作说明广告合作说明广告合作说明广告合作说明广告合作说明广告合作说明广告合作说明广告合作说明
    			广告合作说明广告合作说明广告合作说明广告合作说明广告合作说明广告合作说明广告合作说明广告合作说明
    		</p>
    	</div>
    </div>

    <div class="shenqing">
    	<div style="width:80%;display: flex;align-items: center;justify-content:center;">
    		<span>代理申请&nbsp;<input type="checkbox" name="daili" id="daili" value="" /></span>
    		<span style="margin-left:60px;">广告申请&nbsp;<input type="checkbox" name="guanggao" id="guanggao" value="" /></span>
    	</div>

    	<div class="shenqingbox">
    		<span>姓名<span style="color: #fc7b7b;">*</span></span>
    		<input type="text" name="username" id="username" value="" />
    		<span style="margin-left: 10px;">邮箱<span style="color: #fc7b7b;">*</span></span>
    		<input type="text" name="email" id="email" value="" />
    	</div>
    	<div class="shenqingbox">
    		<span>电话<span style="color: #fc7b7b;">*</span></span>
    		<input type="text" name="tel" id="tel" value="" />
    		<span style="margin-left: 10px;">获取验证码</span>
    		<input type="text" name="code" id="code" value="" placeholder="请输入验证码" />
    	</div>
    	<div class="shenqingbox">
    		<span>意向城市</span>
    		<span style="margin-left: 10px;">省份<span style="color: #fc7b7b;">*</span></span>
    		<input type="text" name="sheng" id="sheng" value="" style="width: 150px;"/>
    		<span style="margin-left: 10px;">城市<span style="color: #fc7b7b;">*</span></span>
    		<input type="text" name="cheng" id="cheng" value="" style="width: 150px;"/>
    		<span style="margin-left: 10px;">区域<span style="color: #fc7b7b;">*</span></span>
    		<input type="text" name="quyu" id="quyu" value="" style="width: 150px;"/>
    	</div>
    	<div class="shenqingbox">
    		<span>备注<span style="color: #fc7b7b;">*</span></span>
    		<input type="text" name="beizhu" id="beizhu" value="" style="width:500px;"/>
    	</div>
    	<div class="zshzbtn">提交申请</div>

    </div>



    <div style="width: 100%;background: #434343;height: 100px;display: flex;align-items: center;justify-content: center;">
    	<img src="../../../static/image/img2.png" style="height:60px;"/>
    	<img src="../../../static/image/logo1.png" style="height:60px;"/>
    </div>
    <div class="footer">
    	<div style="padding-top: 20px;box-sizing: border-box;padding-left: 20px;">
    		<span>营业执照</span>
    		<span>加入我们</span>
    		<span>在线客服</span>
    	</div>
    	<p>版权所有：辽宁卡丁生活科技有限公司</p>
    	<p>辽ICP备20007334号</p>
    </div>
  </div>
</template>

<script>
  import topMenu from './components/topMenu.vue'
  export default {
    components:{
     topMenu
    },
    data() {
      return {

      }
    },
    //初始化
    created(){

    },
    methods:{

    }
  }
</script>

<style scoped>
  /* 设置滚动条的样式 */
  ::-webkit-scrollbar {
  	width: 2px;
  }
  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
  	border-radius: 10px;
  	background: #d2d2d2;
  }

  .logo1 {
  	height:40px;
  }
  .titlebox {
  	width: 100%;
  	height:80px;
  	box-sizing: border-box;
  	position: relative;
  }
  .titlebox p {
  	color: #999;
  	font-size:30px;
  	text-align: center;
  	line-height:40px;
  	font-family: "黑体";
  }
  .titlebox>div {
  	width: 220px;
  	height:30px;
  	position: absolute;
  	left: 50%;
  	transform: translateX(-50%);
  	text-align: center;
  	line-height: 40px;
  	letter-spacing: 1px;
  	font-family: '黑体';
  	font-weight: bold;
  	font-size: 20px;
  	color: #666;
  	display: flex;
  	align-items: center;
  	justify-content: center;
  }
  .titlebox>div>.titleleft {
  	width: calc(50% - 50px);
  	height: 1px;
  	position: absolute;
  	left: 0;
  	top: 50%;
  	background:#f2ea61;
  }
  .titlebox>div>.titleright {
  	width: calc(50% - 50px);
  	height: 1px;
  	position: absolute;
  	right: 0;
  	top: 50%;
  	background:#f2ea61;
  }
  .box {
  	width:1000px;
  	margin: 20px auto;
  	display: flex;
  	align-items: center;
  	justify-content: space-between;
  	box-sizing: border-box;
  }

  .box>div>img {
  	width: 120px;
  }
  .box>div>p {
  	text-align: center;
  	color: #333;
  	font-family: '黑体';
  	font-size: 17px;
  	line-height: 30px;
  }
  .hzjs {
  	width: 100%;
  	height: 400px;
  	background: url(../../../static/image/img1.png) no-repeat;
  	background-size: 100% 100%;
  }
  .hzjsbox {
  	width:1100px;
  	height: 300px;
  	background:rgba(255,255,255,0.4);
  	position: relative;
  	top: 50px;
  	left: calc(50% - 550px);
  	padding:10px 20px;
  	display: flex;
  	flex-direction: column;
  	align-items: center;
  	justify-content: space-around;
  }
  .hzjsbox p {
  	line-height: 35px;
  	color: #000;
  	font-family: "黑体";
  	text-align: left;
  	width: 100%;
  }
  .shenqing {
  	width:900px;
  	height:400px;
  	margin: 20px auto;
  	box-shadow: 0 4px 10px 0 rgba(0, 0, 0,0.5);
  	display: flex;
  	flex-direction: column;
  	align-items: center;
  	justify-content: space-around;
  }
  .shenqingbox {
  	width:90%;
  	height:35px;
  	display: flex;
  	align-items: center;
  	justify-content:flex-start;
  }

  .shenqingbox input {
  	width: 200px;
  	height: 35px;
  	line-height: 35px;
  	padding-left: 10px;
  	box-sizing: border-box;
  	margin-left: 10px;
  }
  .zshzbtn {
  	width:400px;
  	margin:0px auto;
  	background:#f2ea61;
  	color: #fff;
  	font-size: 17px;
  	height:40px;
  	line-height: 40px;
  	text-align: center;
  	border-radius:20px;
  	letter-spacing: 1px;
  	font-family: '黑体';
  }
  .footer {
  	width: 100%;
  	height: 100px;
  	box-sizing: border-box;
  }
  .footer div span {
  	margin-left: 20px;
  	font-size: 14px;
  	line-height: 20px;
  	color: #999;
  }
  .footer p {
  	text-align: center;
  	font-size: 15px;
  	line-height: 20px;
  	color: #666;
  	margin-bottom:5px;
  }
  .suc {
  	width:500px;
  	height: 350px;
  	box-sizing: border-box;
  	display: flex;
  	flex-direction: column;
  	align-items: center;
  	justify-content:center;
  }
  .suc p {
  	font-size: 25px;
  	line-height:40px;
  	color: #000;
  	margin-top: 20px;
  	font-family: '黑体';
  }
  .suc div {
  	margin-top: 20px;
  	font-size: 16px;
  	line-height:35px;
  	color: #000;
  	font-family: '黑体';
  }
</style>



// WEBPACK FOOTER //
// src/components/official/zshz.vue